// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2RbhH","inputWrap":"styles_inputWrap__1mEBr","input":"styles_input__3bETB"};